import { Reducer } from 'redux';
import { ModalsState, ModalsTypes } from './types';

const INITIAL_STATE: ModalsState = {
  statusO: false,
  statusP: false,
  statusRM: false,
  statusF: false,
  statusT: false,
  statusC: false,
  statusI: false,
  step: 0,
  orderComplete: false,
  orderId: 'ID do pedido',
  orderReceipt: 'Comprovante do pedido',
  orderPrepaid: false,
  orderError: {
    merchantId: [],
  },
  product: {
    merchantId: '',
    categoryId: '',
    id: '',
    code: '',
    ean: null,
    priority: 0,
    name: '',
    description: '',
    price: 0,
    availability: '',
    measure: '',
    merchantSuggestion: false,
    isPromotion: false,
    promotion: {
      value: 0,
      validity: '',
      originalValue: 0,
      percent: 0,
    },
    stock: {
      active: false,
      current: 0,
      min: 0,
      orderMax: 0,
    },
    images: [],
    variationsGrid: false,
    variations: [],
  },
  storedAddresses: {
    availableAddresses: [],
    unavailableAddresses: [],
  },
};

const reducer: Reducer = (state = INITIAL_STATE, action) => {
  const updateModal = state;
  switch (action.type) {
    case ModalsTypes.TOGGLE_MODAL_O:
      return { ...state, statusO: !state.statusO };

    case ModalsTypes.TOGGLE_MODAL_P:
      if (action.data === undefined) {
        updateModal.statusP = !state.statusP;
        updateModal.product = { ...INITIAL_STATE.product };
      } else {
        updateModal.statusP = !state.statusP;
        updateModal.product = { ...action.data };
      }
      return {
        ...state,
        ...updateModal,
      };

    case ModalsTypes.TOGGLE_MODAL_RM:
      return { ...state, statusRM: !state.statusRM };

    case ModalsTypes.TOGGLE_MODAL_F:
      return { ...state, statusF: !state.statusF };

    case ModalsTypes.TOGGLE_MODAL_T:
      return { ...state, statusT: !state.statusT };

    case ModalsTypes.TOGGLE_MODAL_C:
      return { ...state, statusC: !state.statusC };

    case ModalsTypes.TOGGLE_MODAL_I:
      return { ...state, statusI: !state.statusI };

    case ModalsTypes.TOGGLE_ORDER_STEP:
      return { ...state, step: action.data };

    case ModalsTypes.TOGGLE_ORDER_COMPLETE:
      return {
        ...state,
        orderComplete: action.complete,
        orderId: action.id,
        orderReceipt: action.receipt,
        orderPrepaid: action.prepaid,
        orderError: action.orderError,
      };

    case ModalsTypes.HANDLE_ADDRESSES:
      return {
        ...state,
        storedAddresses: {
          availableAddresses: action.payload.availableAddresses,
          unavailableAddresses: action.payload.unavailableAddresses,
        },
      };

    default:
      return state;
  }
};

export default reducer;
